import * as React from 'react';
import { 
    Button,
    Box, 
    Typography, 
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Checkbox
} from '@mui/material';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { STYLES, TokenValidator } from '../../../../../utils';
import { Parts, Logger, Orders } from '../../../../../controllers';
import { Confirmation } from '../../../../utils';

export default function Part({partsInfo, reload}) {

    const [part, setPart] = React.useState(partsInfo[0]);
    const [selected, setSelected] = React.useState([]);

    const [reprintResin, SetReprintResin] = React.useState('');

    const [reprintConfirm, showReprintConfirm] = React.useState(false);
    const [gcodeConfirm, showGcodeConfirm] = React.useState(false);
    const [svgConfirm, showSvgConfirm] = React.useState(false);

    const handleSelect = async(e) => {
        const value = Number(e.target.value);
        var delta = [...selected];

        if(!delta.includes(value)){
            delta.push(value);
        }else{
            delta = delta.filter(x => x != value)
        }

        setSelected(delta);
    }

    const handleReprint = async() => {
        if(selected.length < 1){
            alert('No parts were selected');
            return;
        }

        if(reprintResin === ''){
            alert('No resin was selected');
            return;
        }

        const token = await TokenValidator.GetInternalUser();
        const payload = {
            parts : selected,
            resin : reprintResin
        }

        const response = await Parts.Reprint(payload, token);

        if(!response.success){
            alert('Error sending reprint request');
            return;
        }

        selected.forEach(x => {
            const log = {
                type: 'Update',
                title: 'Reprint',
                information: 'Part send for reprint'
            }
            Logger.Part(x, log)
        });

        setSelected([]);
        SetReprintResin('');
        showReprintConfirm(false);
        reload();
    }

    const handleRestart = async() => {
        if(selected.length < 1){
            alert('No parts were selected');
            return;
        }
        
        const token = await TokenValidator.GetInternalUser();
        const payload = {
            order : part.order_id,
            parts : selected
        }

        const response = await Parts.Restart(payload, token);

        if(!response.success){
            alert('Error sending restart request');
            return;
        }

        selected.forEach(x => {
            const log = {
                type: 'Update',
                title: 'Reset',
                information: 'Part send for restart'
            }
            Logger.Part(x, log)
        });

        setSelected([]);
        showGcodeConfirm(false);
        reload();
    }

    const handleSvg = async () => {
        const token = await TokenValidator.GetInternalUser();
        const response = await Parts.UpdateSvg(partsInfo[0].order_id, token);
        
        if(!response.success){
            alert('Error sending SVG update request');
            return;
        }

        showSvgConfirm(false);
        reload();
    }

    const saveBlob = (blob, name) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => window.URL.revokeObjectURL(url), 4000);
    }

    const handleDownloadPartFile = async(kind, filename) => {
        if(!filename){
            return;
        }

        let response;
        if(kind === 'prg' || kind === 'err'){
            const token = await TokenValidator.GetInternalUser();
            response = await Parts.DownloadGcodeFile(part.id, kind, token);
        }else{
            response = await Orders.DownloadFile(part.order_id, filename);
        }

        if(!response || !response.ok){
            alert('File not available.');
            return;
        }

        const blob = await response.blob();
        saveBlob(blob, filename);

        await Logger.Part(part.id, {
            type: 'Update',
            title: 'Files',
            information: `File downloaded: ${filename}`
        });
    }

    const handleUploadPartFiles = async(e) => {
        const files = Array.from(e.target.files || []);
        e.target.value = '';

        if(files.length < 1){
            return;
        }

        if(!window.confirm(`Upload/replace ${files.length} file(s) for this order (part ${part.id})?\nFiles with the same name will be overwritten.`)){
            return;
        }

        const formData = new FormData();
        files.forEach(f => formData.append('files', f));

        const token = await TokenValidator.GetInternalUser();
        const response = await Orders.UploadFiles(part.order_id, formData, token);

        if(!response || !response.success){
            alert(`Error uploading files. ${response && response.message ? response.message : ''}`);
            return;
        }

        const up = response.result ? response.result.uploaded.length : files.length;

        const fileLog = {
            type: 'Update',
            title: 'Files',
            information: `Files uploaded/replaced for part ${part.id} (${up}/${files.length})`
        };
        await Logger.Part(part.id, fileLog);
        await Logger.Order(part.order_id, fileLog);

        alert(`Uploaded ${up}/${files.length}.`);
        reload();
    }

    return(
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Confirmation 
                open={reprintConfirm} 
                onClose={() => {SetReprintResin(''); showReprintConfirm(false);}} 
                onConfirm={handleReprint} 
                title={'Part Reprint'} 
                msg={`The selected pieces will be send to reprint process in ${reprintResin.toUpperCase()} resin.\nDo you wanna proceed?`}
            />

            <Confirmation 
                open={gcodeConfirm} 
                onClose={() => showGcodeConfirm(false)} 
                onConfirm={handleRestart} 
                title={'Part Restart'} 
                msg={`The selected pieces will be send to G-Code resolve process.\nDo you wanna proceed?`}
            />

            <Confirmation 
                open={svgConfirm} 
                onClose={() => showSvgConfirm(false)} 
                onConfirm={handleSvg} 
                title={'Part Laser Resoucer'} 
                msg={`The order pieces will update their Laser marking resource.\nDo you wanna proceed?`}
            />

            <Box
                sx={{
                    minWidth:'100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    backgroundColor:'#1976d2'
                }}
            >
                <Typography variant='h6' color='white'>PARTS INFO</Typography>
            </Box>
            
            
            <br/>
            
            <Box
                sx={{
                    minWidth:'100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    backgroundColor:'#1976d2'
                }}
            >
                <Typography variant='h6' color='white'>ACTIONS</Typography>
            </Box>
                <br />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'Row',
                    gap:2,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        border: 1,
                        borderRadius: 4,
                        flexGrow: 1,
                        borderColor: 'lightgray',
                        padding:2
                    }}
                >
                    <Typography variant='h7'>SENT TO G-CODE</Typography>
                    <Button variant='outlined' color="secondary" onClick={() => showGcodeConfirm(true)}>EXCECUTE</Button>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        border: 1,
                        borderRadius: 4,
                        flexGrow: 1,
                        borderColor: 'lightgray',
                        padding:2
                    }}
                >
                    <Typography variant='h7'>SENT TO REPRINT</Typography>
                    <Box 
                        sx={{
                            display : 'flex',
                            flexDirection : 'row', 
                            gap : 1
                        }}
                    >
                        <Button variant='outlined' fullWidth color="secondary" onClick={() => {SetReprintResin('uma');showReprintConfirm(true);}}>EXCECUTE in UMA</Button>
                        <Button variant='outlined' fullWidth color="secondary" onClick={() => {SetReprintResin('dpr');showReprintConfirm(true);}}>EXCECUTE in DPR</Button>
                    </Box>
                    
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        border: 1,
                        borderRadius: 4,
                        flexGrow: 1,
                        borderColor: 'lightgray',
                        padding:2
                    }}
                >
                    <Typography variant='h7'>UPDATE SVG<span> * No selection required</span></Typography>
                    <Button variant='outlined' color="secondary" onClick={() => showSvgConfirm(true)}>EXCECUTE</Button>
                </Box>

            </Box>

            <br />

            <Divider sx={{minWidth:'100%'}}></Divider>
            
            <Box
                sx={{
                    display : 'flex',
                    flexDirection:'row'
                }}
            >

                <TableContainer sx={{my:2}}>
                    <Table
                        size='small'
                    >
                        <TableHead>
                            <Typography sx={{width:'200%', textWrap: 'nowrap'}}>PART COUNT : {partsInfo.length}</Typography>
                            <TableRow>
                                <TableCell 
                                    align='center'
                                    sx={{...STYLES.Table001.HeadersXS, width:'10%'}}
                                >
                                    ID
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={STYLES.Table001.HeadersXS}
                                >
                                    Type
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={STYLES.Table001.HeadersXS}
                                >
                                    Resin
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={STYLES.Table001.HeadersXS}
                                >
                                    Step
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={STYLES.Table001.HeadersXS}
                                >
                                    Side
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={STYLES.Table001.HeadersXS}
                                >
                                    Status
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={STYLES.Table001.HeadersXS}
                                >
                                    Updated
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={STYLES.Table001.HeadersXS}
                                >
                                    Action
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={STYLES.Table001.HeadersXS}
                                >
                                    Logs
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {partsInfo.length > 0 && partsInfo.map((row, i) => (
                                <TableRow hover selected={part.id === row.id} onClick={() => setPart(row)} sx={{cursor:'pointer'}}>
                                    <TableCell align='center'>
                                        {row.id}
                                    </TableCell>
                                    <TableCell align='center'>
                                        {row.data_general.type}
                                    </TableCell>
                                    <TableCell align='center'>
                                        {row.data_3d === null ? ' -- ' : row.data_3d.type.toUpperCase()}
                                    </TableCell>
                                    <TableCell align='center'>
                                        {row.step}
                                    </TableCell>
                                    <TableCell align='center'>
                                        {row.side == 1 ? <FileUploadIcon sx={{color:'lightgreen'}}/> : <FileDownloadIcon sx={{color:'lightsalmon'}}/>}
                                    </TableCell>
                                    <TableCell align='center'>
                                        {row.status}
                                    </TableCell>
                                    <TableCell align='center'>
                                        {new Date(row.date_update).toLocaleDateString()}
                                    </TableCell>
                                    <TableCell align='center' onClick={(e) => e.stopPropagation()}>
                                        <Checkbox value={row.id} onChange={handleSelect} checked={selected.includes(row.id)}/>
                                    </TableCell>
                                    <TableCell align='center'>
                                        <IconButton onClick={() => setPart(row)}>
                                            <TextSnippetIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                
                <Divider variant='middle' />

                <Box sx={{display:'flex', flexDirection:'column', width:'50%'}}>

                <Typography sx={{textWrap:'nowrap', mt:1}}>PART FILES : {part.id}</Typography>
                <Box sx={{display:'flex', flexDirection:'row', flexWrap:'wrap', gap:1, my:1}}>
                    {['stl','pts','svg','prg','err'].map((k) => {
                        const fn = (part.data_general && part.data_general.resources) ? part.data_general.resources[k] : '';
                        return (
                            <Button key={k} size='small' variant='outlined' color={k === 'err' ? 'error' : 'secondary'} disabled={!fn} startIcon={<FileDownloadIcon/>} onClick={() => handleDownloadPartFile(k, fn)}>
                                {k.toUpperCase()}
                            </Button>
                        );
                    })}
                    <Button size='small' variant='contained' component='label' color='primary' startIcon={<FileUploadIcon/>}>
                        UPLOAD
                        <input hidden type='file' multiple accept='.stl,.pts,.svg,.prg' onChange={handleUploadPartFiles}/>
                    </Button>
                </Box>

                <TableContainer sx={{my:2}}>
                    <Table
                        size='small'
                    >
                        <TableHead>
                            <Typography sx={{textWrap:'nowrap'}}>PART ID : {part.id}</Typography>
                            <TableRow>
                                <TableCell 
                                    align='center'
                                    sx={STYLES.Table001.HeadersXS}
                                >
                                    Event
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={STYLES.Table001.HeadersXS}
                                >
                                    Info
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={STYLES.Table001.HeadersXS}
                                >
                                    Date
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {part.logs.length > 0 && part.logs.map((row, i) => (
                                <TableRow>
                                    <TableCell align='center'>
                                        {row.data.title}
                                    </TableCell>
                                    <TableCell >
                                        {row.data.information}
                                    </TableCell>

                                    <TableCell align='center'>
                                        {new Date(row.epoc * 1000).toLocaleString()}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                </Box>

            </Box>

        </Box>
    );
}
